import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import Layout from "../../components/one/Layout"
import TopContact from "../../components/one/TopContact"
import TopFeature from "../../components/one/TopFeature"
import TopInstagram from "../../components/one/TopInstagram"
import TopPartners from "../../components/one/TopPartners"
import TopSlider from "../../components/one/TopSlider"
import SEO from "../../components/Seo"
import About from "../../components/one/TopAbout"
import Concept from "../../components/shared/top/Concept"
import OpeningShutter from "../../components/shared/top/OpeningShutter"

const query = graphql`
  query {
    logo: file(relativePath: { eq: "one/logo.png" }) {
      childImageSharp {
        gatsbyImageData(width: 100)
      }
    }
  }
`

const index = () => {
  const data = useStaticQuery(query)
  return (
    <Layout>
      <SEO siteTitle="one" />
      <OpeningShutter logo={getImage(data.logo)} target="one" />
      <TopSlider />
      <Concept name="one" bgDotes="md:bg-oneFourDots" />
      <About target="one" />
      <TopFeature />
      <TopInstagram />
      <TopPartners />
      <TopContact />
    </Layout>
  )
}

export default index
